module.exports = __webpack_public_path__ + "img/1526278698.3adebe38.jpg";